import { Component } from '@angular/core';
import { CityParkingDiscountResponse } from '../../../../core/models/card.model';
import { InputComponent } from "../../../../tools/forms/input/input.component";
import { CommonModule } from '@angular/common';
import { Providers } from '../../../../core/models/information.model';
import { MyVehicleAllResponse } from '../../../../core/models/user.model';
import { FormsModule } from '@angular/forms';
import { ApiService } from '../../../../core/services/api.service';
import { SelectComponent } from "../../../../tools/forms/select/select.component";
import { ToastNotifService } from '../../../../core/services/toast-notif.service';
import * as XLSX from 'xlsx';
import { Router } from '@angular/router';
import { PssLoadingComponent } from "../../../../tools/template/pss/pss-loading/pss-loading.component";
import { ApiHandlerService } from '../../../../tools/services/api/handler-api/apiHandler.service';
import { ToastService } from 'angular-toastify';
import { ApiFormService } from '../../../../core/services/api-form.service';
@Component({
  selector: 'app-discount-card',
  imports: [
    CommonModule,
    FormsModule,
    InputComponent,
    PssLoadingComponent,
  ],
  templateUrl: './discount-card.component.html',
  styleUrl: './discount-card.component.css'
})
export class DiscountCardComponent {

  cityparkingDiscount: CityParkingDiscountResponse[] = [
    // {
    //   siteId: 101,
    //   name: 'ส่วนลดลูกค้า VIP',
    //   type: true,
    //   amount: 20,
    //   startDate: new Date('2025-10-01'),
    //   endDate: new Date('2025-12-31'),
    //   status: 4,
    //   codePrefix : 'ASVDSTEW',
    //   qty: 1,
    //   maxUsage: 10,
    //   approveDate : new Date('2025-10-01'),
    //   remark: 'ส่วนลดลูกค้า VIP'
    // },
    // {
    //   siteId: 102,
    //   name: 'ส่วนลดรายเดือน',
    //   type: false,
    //   amount: 100,
    //   startDate: new Date('2025-09-01'),
    //   endDate: new Date('2025-09-30'),
    //   status: 2,
    //   codePrefix : 'ASVDSTEW',
    //   qty: 1,
    //   maxUsage: 10,
    //   approveDate : new Date('2025-10-01'),
    //   remark: 'ส่วนลดรายเดือน'
    // },
    // {
    //   siteId: 103,
    //   name: 'โปรโมชั่นเทศกาล',
    //   type: true,
    //   amount: 15,
    //   startDate: new Date('2025-10-10'),
    //   endDate: new Date('2025-11-10'),
    //   status: 1,
    //   codePrefix : 'ASVDSTEW',
    //   qty: 1,
    //   maxUsage: 10,
    //   approveDate : new Date('2025-10-01'),
    //   remark: 'โปรโมชั่นเทศกาล'
    // },
  ];

  filteredCityparkingDiscount: CityParkingDiscountResponse[] | null = null;
  searchCardDiscount: string = '';
  discountCard: CityParkingDiscountResponse[] = [];

  // Site
  selectSite: number = 0
  allProviders: Providers[] = [];
  vehicle: MyVehicleAllResponse[] = [];

  // API 
  endDate: string = new Date().toISOString().slice(0, 10);
  startDate: string = new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toISOString().slice(0, 10);

  // Table
  currentPage: number = 1;
  pageSize: number = 10;

  // Modal
  showModalCreate: boolean = false
  showModalSome: boolean = false
  showModalSite: boolean = true
  // Loading
  isLoading: boolean = false

  constructor(
    private router: Router,
    private apiService: ApiService,
    private apiFormService: ApiFormService,
    private toast: ToastService,
    private apiHandler: ApiHandlerService
  ) {

  }
  ngOnInit() {
    this.isLoading = true;

    // Default
    this.getProviders();

    this.getCityparkingDiscount()
  }

  /* -------------------------------------------- Function --------------------------------------------*/

  /* --- Style --- */
  // Table
  get totalPages(): number {
    return Math.ceil(this.cityparkingDiscount.length / this.pageSize);
  }

  get paginatedData() {
    const start = (this.currentPage - 1) * this.pageSize;
    return this.cityparkingDiscount.slice(start, start + this.pageSize);
  }

  nextPage() {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
    }
  }

  prevPage() {
    if (this.currentPage > 1) {
      this.currentPage--;
    }
  }


  /* --- Function --- */
  // Modal
  openCreateModal() {
    this.showModalCreate = true
  }

  /* --- CardAdvancesApprove --- */
  // ( Search )
  onSearchCardDiscount(value: any) {
    // Perform search logic here
    this.searchCardDiscount = value;

    if (this.searchCardDiscount === '') {
      this.filteredCityparkingDiscount = null;
      return;
    }

    this.filteredCityparkingDiscount = this.cityparkingDiscount.filter(card =>
      card.name.toLowerCase().includes(this.searchCardDiscount.toLowerCase())
    );

  }
  onClickSearch() {
    if (!this.startDate || !this.endDate) {
      this.toast.error('กรุณาเลือกช่วงวันที่');
      return
    }
    this.getCityparkingDiscount();
  }

  navigateToDetailCreate() {
    this.router.navigate([`/discount-card-details`]);
    //console.log("id :", id , this.router.url);
  }
  navigateToDetailById(id: number) {
    this.router.navigate([`/discount-card-details/${id}`]);
    //console.log("id :", id , this.router.url);
  }
  onSaveModal() {
    this.showModalSome = false
  }
  onSaveCreateModal() {
    this.showModalSome = false
  }

  /* -------------------------------------------- API --------------------------------------------*/
  /* --- Default --- */
  getProviders() {
    this.apiHandler.handleApi(
      this.apiFormService.getProviders(),
      {
        logLabel: 'getProvider',
        isConsoleLog: true,
        loading: (loading: boolean) => this.isLoading = loading,
        success: (response: any) => {
          this.allProviders = response;
        },
      }
    );
  }

  async getCityparkingDiscount() {
    this.apiHandler.handleApi(
      this.apiService.getCityparkingDiscount(this.startDate, this.endDate),
      {
        logLabel: 'getCityparkingDiscount',
        isConsoleLog: true,
        loading: (loading: boolean) => this.isLoading = loading,
        success: (response: CityParkingDiscountResponse[]) => {
          this.cityparkingDiscount = response;
        },
        error: (error) => {
          this.toast.error('เกิดข้อผิดพลาดในการดึงข้อมูล');
        }
      }
    )
  }

}